import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-record-title"
}

import { computed } from 'vue'

import { TripFullWithRelations } from '@/models/trip'

import CheckInItem from '@/components/CheckInItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckInSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const checkIns = computed(() => props.trip.checkIns)

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (!checkIns.value.length)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "No check-in record"))
    : (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "check-ins-container"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkIns.value, (checkIn) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              key: checkIn.id,
              span: 24,
              class: "check-in-col"
            }, {
              default: _withCtx(() => [
                _createVNode(CheckInItem, {
                  trip: _ctx.trip,
                  checkIn: checkIn
                }, null, 8, ["trip", "checkIn"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
}
}

})